/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
import { DateTime } from 'luxon';

/* eslint-disable no-restricted-syntax */
/* eslint-disable no-undef */
const departmentFrequencyByLoc = {
  '1-1': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Montevideo',
      deptNombre: 'Montevideo',
    },
  },
  '183-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Aeroparque',
      deptNombre: 'Canelones',
    },
  },
  '199-2': {
    agency: [
      3,
      5,
    ],
    simple: [
      3,
      5,
    ],
    special: [
      3,
      5,
    ],
    _meta: {
      locNombre: 'Aguas Corrientes',
      deptNombre: 'Canelones',
    },
  },
  '125-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Araminda',
      deptNombre: 'Canelones',
    },
  },
  '22-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Atlantida',
      deptNombre: 'Canelones',
    },
  },
  '346-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Argentino',
      deptNombre: 'Canelones',
    },
  },
  '5-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Barra de Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '89-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Barros Blancos',
      deptNombre: 'Canelones',
    },
  },
  '216-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Bello Horizonte',
      deptNombre: 'Canelones',
    },
  },
  '219-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Biarritz',
      deptNombre: 'Canelones',
    },
  },
  '377-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Bolivar',
      deptNombre: 'Canelones',
    },
  },
  '154-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Canelon Chico',
      deptNombre: 'Canelones',
    },
  },
  '27-2': {
    agency: [
      3,
      5,
    ],
    simple: [
      3,
      5,
    ],
    special: [
      3,
      5,
    ],
    _meta: {
      locNombre: 'Canelones',
      deptNombre: 'Canelones',
    },
  },
  '201-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Carrasco del Sauce',
      deptNombre: 'Canelones',
    },
  },
  '342-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Cassarino',
      deptNombre: 'Canelones',
    },
  },
  '180-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Castellanos',
      deptNombre: 'Canelones',
    },
  },
  '88-2': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Cerrillos',
      deptNombre: 'Canelones',
    },
  },
  '398-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'City Golf',
      deptNombre: 'Canelones',
    },
  },
  '397-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colinas de Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '166-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colinas de Solymar',
      deptNombre: 'Canelones',
    },
  },
  '167-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colonia Lamas',
      deptNombre: 'Canelones',
    },
  },
  '81-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Colonia Nicolich',
      deptNombre: 'Canelones',
    },
  },
  '26-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Costa Azul',
      deptNombre: 'Canelones',
    },
  },
  '127-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Cuchilla Alta',
      deptNombre: 'Canelones',
    },
  },
  '9-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'El Bosque',
      deptNombre: 'Canelones',
    },
  },
  '236-2': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'El Colorado',
      deptNombre: 'Canelones',
    },
  },
  '14-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'El Pinar',
      deptNombre: 'Canelones',
    },
  },
  '235-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Empalme del Sauce',
      deptNombre: 'Canelones',
    },
  },
  '309-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Empalme Nicolich',
      deptNombre: 'Canelones',
    },
  },
  '99-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Empalme Olmos',
      deptNombre: 'Canelones',
    },
  },
  '407-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Estación Atlántida',
      deptNombre: 'Canelones',
    },
  },
  '20-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Fortin de Santa Rosa',
      deptNombre: 'Canelones',
    },
  },
  '402-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Frac. Cno. Andaluz y R.84',
      deptNombre: 'Canelones',
    },
  },
  '417-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Fraccionamiento Ruta 74',
      deptNombre: 'Canelones',
    },
  },
  '271-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Guazuvira',
      deptNombre: 'Canelones',
    },
  },
  '218-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Guazuvira Nuevo',
      deptNombre: 'Canelones',
    },
  },
  '170-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Jaureguiberry',
      deptNombre: 'Canelones',
    },
  },
  '104-2': {
    agency: [
      3,
      5,
    ],
    simple: [
      3,
      5,
    ],
    special: [
      3,
      5,
    ],
    _meta: {
      locNombre: 'Joanico',
      deptNombre: 'Canelones',
    },
  },
  '148-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Capilla',
      deptNombre: 'Canelones',
    },
  },
  '25-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'La Floresta',
      deptNombre: 'Canelones',
    },
  },
  '461-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Montañesa',
      deptNombre: 'Canelones',
    },
  },
  '40-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Palmita',
      deptNombre: 'Canelones',
    },
  },
  '31-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Paz',
      deptNombre: 'Canelones',
    },
  },
  '212-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'La Tuna',
      deptNombre: 'Canelones',
    },
  },
  '8-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Lagomar',
      deptNombre: 'Canelones',
    },
  },
  '107-2': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Las Brujas',
      deptNombre: 'Canelones',
    },
  },
  '28-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Piedras',
      deptNombre: 'Canelones',
    },
  },
  '23-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Las Toscas',
      deptNombre: 'Canelones',
    },
  },
  '270-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Vegas',
      deptNombre: 'Canelones',
    },
  },
  '237-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Lomas de Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '13-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Lomas de Solymar',
      deptNombre: 'Canelones',
    },
  },
  '192-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Los Titanes',
      deptNombre: 'Canelones',
    },
  },
  '19-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Marindia',
      deptNombre: 'Canelones',
    },
  },
  '98-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Medanos de Solymar',
      deptNombre: 'Canelones',
    },
  },
  '141-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Migues',
      deptNombre: 'Canelones',
    },
  },
  '95-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Montes',
      deptNombre: 'Canelones',
    },
  },
  '169-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Montes de Solymar',
      deptNombre: 'Canelones',
    },
  },
  '15-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Neptunia',
      deptNombre: 'Canelones',
    },
  },
  '29-2': {
    agency: [
      1,
      3,
      5,
    ],
    simple: [
      1,
      3,
      5,
    ],
    special: [
      1,
      3,
      5,
    ],
    _meta: {
      locNombre: 'Pando',
      deptNombre: 'Canelones',
    },
  },
  '387-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parada Cabrera',
      deptNombre: 'Canelones',
    },
  },
  '108-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parada Rodo',
      deptNombre: 'Canelones',
    },
  },
  '206-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paraje La Victoria',
      deptNombre: 'Canelones',
    },
  },
  '82-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parque Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '11-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parque de Solymar',
      deptNombre: 'Canelones',
    },
  },
  '24-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Parque del Plata',
      deptNombre: 'Canelones',
    },
  },
  '3-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parque Miramar',
      deptNombre: 'Canelones',
    },
  },
  '6-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parque Roosvelt',
      deptNombre: 'Canelones',
    },
  },
  '4-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '383-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso de la Cadena',
      deptNombre: 'Canelones',
    },
  },
  '444-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso de Pache',
      deptNombre: 'Canelones',
    },
  },
  '419-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso Espinosa',
      deptNombre: 'Canelones',
    },
  },
  '373-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pedernal',
      deptNombre: 'Canelones',
    },
  },
  '280-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Piedras de Afilar',
      deptNombre: 'Canelones',
    },
  },
  '16-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Pinamar',
      deptNombre: 'Canelones',
    },
  },
  '187-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pinares Solymar',
      deptNombre: 'Canelones',
    },
  },
  '71-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Progreso',
      deptNombre: 'Canelones',
    },
  },
  '37-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Cap.J.Artigas',
      deptNombre: 'Canelones',
    },
  },
  '257-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Montes',
      deptNombre: 'Canelones',
    },
  },
  '196-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rincon de Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '225-2': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Rincon del Colorado',
      deptNombre: 'Canelones',
    },
  },
  '18-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Salinas',
      deptNombre: 'Canelones',
    },
  },
  '178-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'San Antonio',
      deptNombre: 'Canelones',
    },
  },
  '72-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'San Bautista',
      deptNombre: 'Canelones',
    },
  },
  '73-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'San Jacinto',
      deptNombre: 'Canelones',
    },
  },
  '7-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Jose de Carrasco',
      deptNombre: 'Canelones',
    },
  },
  '156-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'San Luis',
      deptNombre: 'Canelones',
    },
  },
  '41-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'San Ramon',
      deptNombre: 'Canelones',
    },
  },
  '186-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Santa Ana',
      deptNombre: 'Canelones',
    },
  },
  '30-2': {
    agency: [
      3,
      5,
    ],
    simple: [
      3,
      5,
    ],
    special: [
      3,
      5,
    ],
    _meta: {
      locNombre: 'Santa Lucia',
      deptNombre: 'Canelones',
    },
  },
  '137-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Santa Lucia del Este',
      deptNombre: 'Canelones',
    },
  },
  '57-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Santa Rosa',
      deptNombre: 'Canelones',
    },
  },
  '181-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Teresita',
      deptNombre: 'Canelones',
    },
  },
  '155-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santos Lugares',
      deptNombre: 'Canelones',
    },
  },
  '86-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Sauce',
      deptNombre: 'Canelones',
    },
  },
  '2-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Shangrila',
      deptNombre: 'Canelones',
    },
  },
  '194-2': {
    agency: [
      3,
    ],
    simple: [
      3,
    ],
    special: [
      3,
    ],
    _meta: {
      locNombre: 'Soca',
      deptNombre: 'Canelones',
    },
  },
  '171-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Solis',
      deptNombre: 'Canelones',
    },
  },
  '10-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Solymar',
      deptNombre: 'Canelones',
    },
  },
  '67-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Suarez',
      deptNombre: 'Canelones',
    },
  },
  '80-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Tala',
      deptNombre: 'Canelones',
    },
  },
  '292-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tapia',
      deptNombre: 'Canelones',
    },
  },
  '69-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Toledo',
      deptNombre: 'Canelones',
    },
  },
  '322-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Toledo Chico',
      deptNombre: 'Canelones',
    },
  },
  '379-2': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Totoral del Sauce',
      deptNombre: 'Canelones',
    },
  },
  '375-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa 6 Hermanos',
      deptNombre: 'Canelones',
    },
  },
  '399-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Arejo',
      deptNombre: 'Canelones',
    },
  },
  '21-2': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Villa Argentina',
      deptNombre: 'Canelones',
    },
  },
  '414-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Villa Crespo y San Andrés',
      deptNombre: 'Canelones',
    },
  },
  '300-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Olmos',
      deptNombre: 'Canelones',
    },
  },
  '394-2': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa San Cono',
      deptNombre: 'Canelones',
    },
  },
  '92-2': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Villa San José',
      deptNombre: 'Canelones',
    },
  },
  '431-3': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Andresito',
      deptNombre: 'Flores',
    },
  },
  '281-3': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Flores',
      deptNombre: 'Flores',
    },
  },
  '299-3': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Ismael Cortinas',
      deptNombre: 'Flores',
    },
  },
  '17-3': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Trinidad',
      deptNombre: 'Flores',
    },
  },
  '228-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Autodromo Nacional',
      deptNombre: 'San José',
    },
  },
  '249-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Boca del Cufre',
      deptNombre: 'San José',
    },
  },
  '96-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colonia Wilson',
      deptNombre: 'San José',
    },
  },
  '51-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Delta del Tigre',
      deptNombre: 'San José',
    },
  },
  '100-4': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Ecilda Paullier',
      deptNombre: 'San José',
    },
  },
  '168-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Estacion Gonzalez',
      deptNombre: 'San José',
    },
  },
  '305-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Ituzaingo',
      deptNombre: 'San José',
    },
  },
  '451-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Juan Soler',
      deptNombre: 'San José',
    },
  },
  '119-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Kiyu',
      deptNombre: 'San José',
    },
  },
  '60-4': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Libertad',
      deptNombre: 'San José',
    },
  },
  '136-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Mal Abrigo',
      deptNombre: 'San José',
    },
  },
  '361-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Monte Grande',
      deptNombre: 'San José',
    },
  },
  '261-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parque Postel',
      deptNombre: 'San José',
    },
  },
  '33-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Playa Pascual',
      deptNombre: 'San José',
    },
  },
  '293-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Capurro',
      deptNombre: 'San José',
    },
  },
  '287-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Ituzaingo',
      deptNombre: 'San José',
    },
  },
  '282-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Nuevo',
      deptNombre: 'San José',
    },
  },
  '123-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Puntas de Valdéz',
      deptNombre: 'San José',
    },
  },
  '438-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Radial Ruta 3',
      deptNombre: 'San José',
    },
  },
  '210-4': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Rafael Perazza',
      deptNombre: 'San José',
    },
  },
  '450-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Raigón',
      deptNombre: 'San José',
    },
  },
  '121-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Rincon de La Bolsa',
      deptNombre: 'San José',
    },
  },
  '131-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rincon de La Torre',
      deptNombre: 'San José',
    },
  },
  '49-4': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Rincon del Pino',
      deptNombre: 'San José',
    },
  },
  '413-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Safici',
      deptNombre: 'San José',
    },
  },
  '229-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'San Fernando',
      deptNombre: 'San José',
    },
  },
  '409-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'San Fernando Chico',
      deptNombre: 'San José',
    },
  },
  '129-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Gregorio (San José)',
      deptNombre: 'San José',
    },
  },
  '32-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San José',
      deptNombre: 'San José',
    },
  },
  '412-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Mónica',
      deptNombre: 'San José',
    },
  },
  '231-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Victoria',
      deptNombre: 'San José',
    },
  },
  '410-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tomás Penino',
      deptNombre: 'San José',
    },
  },
  '226-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Veinticinco de Mayo',
      deptNombre: 'San José',
    },
  },
  '436-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa María',
      deptNombre: 'San José',
    },
  },
  '203-4': {
    agency: [
      2,
      6,
    ],
    simple: [
      2,
      6,
    ],
    special: [
      2,
      6,
    ],
    _meta: {
      locNombre: 'Villa Rives',
      deptNombre: 'San José',
    },
  },
  '79-4': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Rodriguez',
      deptNombre: 'San José',
    },
  },
  '434-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: '18 de Julio',
      deptNombre: 'Rocha',
    },
  },
  '376-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: '19 de abril',
      deptNombre: 'Rocha',
    },
  },
  '240-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Aguas Dulces',
      deptNombre: 'Rocha',
    },
  },
  '294-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Arachania',
      deptNombre: 'Rocha',
    },
  },
  '241-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Barra de Valizas',
      deptNombre: 'Rocha',
    },
  },
  '277-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Barra del Chuy',
      deptNombre: 'Rocha',
    },
  },
  '371-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cabo Polonio',
      deptNombre: 'Rocha',
    },
  },
  '35-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Castillos',
      deptNombre: 'Rocha',
    },
  },
  '165-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cebollati',
      deptNombre: 'Rocha',
    },
  },
  '209-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Chuy',
      deptNombre: 'Rocha',
    },
  },
  '272-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Costa Azul (Rocha)',
      deptNombre: 'Rocha',
    },
  },
  '391-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'El Caracol',
      deptNombre: 'Rocha',
    },
  },
  '291-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'La Aguada',
      deptNombre: 'Rocha',
    },
  },
  '205-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'La Coronilla',
      deptNombre: 'Rocha',
    },
  },
  '348-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'La Esmeralda',
      deptNombre: 'Rocha',
    },
  },
  '65-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'La Paloma',
      deptNombre: 'Rocha',
    },
  },
  '264-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'La Pedrera',
      deptNombre: 'Rocha',
    },
  },
  '433-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Riviera',
      deptNombre: 'Rocha',
    },
  },
  '365-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Laguna Garzón',
      deptNombre: 'Rocha',
    },
  },
  '61-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Lascano',
      deptNombre: 'Rocha',
    },
  },
  '403-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Palmares de la Coronilla',
      deptNombre: 'Rocha',
    },
  },
  '395-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Puimayen',
      deptNombre: 'Rocha',
    },
  },
  '245-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Punta del Diablo',
      deptNombre: 'Rocha',
    },
  },
  '297-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Punta Rubia',
      deptNombre: 'Rocha',
    },
  },
  '34-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Rocha',
      deptNombre: 'Rocha',
    },
  },
  '447-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Antonio',
      deptNombre: 'Rocha',
    },
  },
  '331-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Luis',
      deptNombre: 'Rocha',
    },
  },
  '462-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Isabel',
      deptNombre: 'Rocha',
    },
  },
  '244-5': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Santa Teresa',
      deptNombre: 'Rocha',
    },
  },
  '463-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tajamares de la Pedrera',
      deptNombre: 'Rocha',
    },
  },
  '230-5': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Velazquez',
      deptNombre: 'Rocha',
    },
  },
  '324-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Achar',
      deptNombre: 'Tacuarembó',
    },
  },
  '298-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Ipora',
      deptNombre: 'Tacuarembó',
    },
  },
  '334-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Caraguata',
      deptNombre: 'Tacuarembó',
    },
  },
  '396-6': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Cuchilla Peralta',
      deptNombre: 'Tacuarembó',
    },
  },
  '296-6': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Curtina',
      deptNombre: 'Tacuarembó',
    },
  },
  '389-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Toscas',
      deptNombre: 'Tacuarembó',
    },
  },
  '421-6': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Paso Bonilla',
      deptNombre: 'Tacuarembó',
    },
  },
  '94-6': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Paso de Los Toros',
      deptNombre: 'Tacuarembó',
    },
  },
  '435-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rincón del Bonete',
      deptNombre: 'Tacuarembó',
    },
  },
  '213-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Gregorio de Polanco',
      deptNombre: 'Tacuarembó',
    },
  },
  '39-6': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Tacuarembó',
      deptNombre: 'Tacuarembó',
    },
  },
  '247-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tambores',
      deptNombre: 'Tacuarembó',
    },
  },
  '246-6': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Ansina',
      deptNombre: 'Tacuarembó',
    },
  },
  '111-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: '25 de Agosto',
      deptNombre: 'Florida',
    },
  },
  '211-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: '25 de Mayo',
      deptNombre: 'Florida',
    },
  },
  '256-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Capilla del Sauce',
      deptNombre: 'Florida',
    },
  },
  '126-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cardal',
      deptNombre: 'Florida',
    },
  },
  '185-7': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Casupa',
      deptNombre: 'Florida',
    },
  },
  '266-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro Chato(Florida)',
      deptNombre: 'Florida',
    },
  },
  '101-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro Colorado',
      deptNombre: 'Florida',
    },
  },
  '68-7': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Chamizo',
      deptNombre: 'Florida',
    },
  },
  '42-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Florida',
      deptNombre: 'Florida',
    },
  },
  '145-7': {
    agency: [
      2,
      4,
    ],
    simple: [
      2,
      4,
    ],
    special: [
      2,
      4,
    ],
    _meta: {
      locNombre: 'Fray Marcos',
      deptNombre: 'Florida',
    },
  },
  '336-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Illescas',
      deptNombre: 'Florida',
    },
  },
  '445-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Independencia',
      deptNombre: 'Florida',
    },
  },
  '343-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'La cruz',
      deptNombre: 'Florida',
    },
  },
  '378-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Macana',
      deptNombre: 'Florida',
    },
  },
  '202-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Mendoza Chico',
      deptNombre: 'Florida',
    },
  },
  '132-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Mendoza Grande',
      deptNombre: 'Florida',
    },
  },
  '307-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Nico Peréz',
      deptNombre: 'Florida',
    },
  },
  '382-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Parada Sanchez',
      deptNombre: 'Florida',
    },
  },
  '255-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Pintado',
      deptNombre: 'Florida',
    },
  },
  '393-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Pueblo Goñi',
      deptNombre: 'Florida',
    },
  },
  '420-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Puntas de Maciel',
      deptNombre: 'Florida',
    },
  },
  '358-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Reboledo',
      deptNombre: 'Florida',
    },
  },
  '411-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Gabriel',
      deptNombre: 'Florida',
    },
  },
  '90-7': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Sarandi Grande',
      deptNombre: 'Florida',
    },
  },
  '158-7': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Talita',
      deptNombre: 'Florida',
    },
  },
  '350-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Baygorria',
      deptNombre: 'Durazno',
    },
  },
  '152-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Blanquillo',
      deptNombre: 'Durazno',
    },
  },
  '288-8': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Carlos Reyles',
      deptNombre: 'Durazno',
    },
  },
  '283-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Centenario',
      deptNombre: 'Durazno',
    },
  },
  '269-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro Chato(Durazno)',
      deptNombre: 'Durazno',
    },
  },
  '164-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Comandita',
      deptNombre: 'Durazno',
    },
  },
  '443-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cuchilla de Ramírez',
      deptNombre: 'Durazno',
    },
  },
  '43-8': {
    agency: [
      4,
    ],
    simple: [
      4,
    ],
    special: [
      4,
    ],
    _meta: {
      locNombre: 'Durazno',
      deptNombre: 'Durazno',
    },
  },
  '138-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Paloma',
      deptNombre: 'Durazno',
    },
  },
  '159-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Minas',
      deptNombre: 'Durazno',
    },
  },
  '110-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Molles',
      deptNombre: 'Durazno',
    },
  },
  '405-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paraje Parish',
      deptNombre: 'Durazno',
    },
  },
  '360-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Jorge',
      deptNombre: 'Durazno',
    },
  },
  '177-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Bernardina',
      deptNombre: 'Durazno',
    },
  },
  '102-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Sarandi del Yi',
      deptNombre: 'Durazno',
    },
  },
  '44-8': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa del Carmen',
      deptNombre: 'Durazno',
    },
  },
  '457-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: '#Maldonado',
      deptNombre: 'Maldonado',
    },
  },
  '84-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Aigua',
      deptNombre: 'Maldonado',
    },
  },
  '109-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Barra de Maldonado',
      deptNombre: 'Maldonado',
    },
  },
  '273-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Bella Vista',
      deptNombre: 'Maldonado',
    },
  },
  '352-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Buenos Aires',
      deptNombre: 'Maldonado',
    },
  },
  '392-9': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Cerros Azules',
      deptNombre: 'Maldonado',
    },
  },
  '384-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Chiuahua',
      deptNombre: 'Maldonado',
    },
  },
  '442-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Eden Rock',
      deptNombre: 'Maldonado',
    },
  },
  '353-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'El Chorro',
      deptNombre: 'Maldonado',
    },
  },
  '449-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'El Edén',
      deptNombre: 'Maldonado',
    },
  },
  '367-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'El Tesoro',
      deptNombre: 'Maldonado',
    },
  },
  '460-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Estación Las Flores',
      deptNombre: 'Maldonado',
    },
  },
  '448-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Garzón',
      deptNombre: 'Maldonado',
    },
  },
  '120-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Gregorio Aznares',
      deptNombre: 'Maldonado',
    },
  },
  '295-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Jose Ignacio',
      deptNombre: 'Maldonado',
    },
  },
  '363-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Capuera',
      deptNombre: 'Maldonado',
    },
  },
  '151-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Laguna del Sauce',
      deptNombre: 'Maldonado',
    },
  },
  '364-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Laguna Garzón',
      deptNombre: 'Maldonado',
    },
  },
  '143-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Flores',
      deptNombre: 'Maldonado',
    },
  },
  '262-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Los Talas',
      deptNombre: 'Maldonado',
    },
  },
  '45-9': {
    agency: [
      3,
      6,
    ],
    simple: [
      3,
      6,
    ],
    special: [
      3,
      6,
    ],
    _meta: {
      locNombre: 'Maldonado',
      deptNombre: 'Maldonado',
    },
  },
  '214-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Manantiales',
      deptNombre: 'Maldonado',
    },
  },
  '369-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Nueva Carrara',
      deptNombre: 'Maldonado',
    },
  },
  '339-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Ocean Park',
      deptNombre: 'Maldonado',
    },
  },
  '103-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pan de Azucar',
      deptNombre: 'Maldonado',
    },
  },
  '50-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Piriapolis',
      deptNombre: 'Maldonado',
    },
  },
  '184-9': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Playa Grande (Piriapolis)',
      deptNombre: 'Maldonado',
    },
  },
  '215-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Playa Hermosa',
      deptNombre: 'Maldonado',
    },
  },
  '163-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Playa Verde',
      deptNombre: 'Maldonado',
    },
  },
  '87-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Portezuelo',
      deptNombre: 'Maldonado',
    },
  },
  '381-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Gerona',
      deptNombre: 'Maldonado',
    },
  },
  '83-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Punta Ballena',
      deptNombre: 'Maldonado',
    },
  },
  '195-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Punta Colorada',
      deptNombre: 'Maldonado',
    },
  },
  '46-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Punta del Este',
      deptNombre: 'Maldonado',
    },
  },
  '147-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Punta Fria',
      deptNombre: 'Maldonado',
    },
  },
  '338-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Punta Negra',
      deptNombre: 'Maldonado',
    },
  },
  '47-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Carlos',
      deptNombre: 'Maldonado',
    },
  },
  '191-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Francisco(Piriapolis)',
      deptNombre: 'Maldonado',
    },
  },
  '157-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Rafael - El Placer',
      deptNombre: 'Maldonado',
    },
  },
  '390-9': {
    agency: [
      6,
    ],
    simple: [
      6,
    ],
    special: [
      6,
    ],
    _meta: {
      locNombre: 'Santa Monica',
      deptNombre: 'Maldonado',
    },
  },
  '368-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Sauce de Portezuelo',
      deptNombre: 'Maldonado',
    },
  },
  '113-9': {
    agency: [
      1,
      3,
      5,
      6,
    ],
    simple: [
      1,
      3,
      5,
      6,
    ],
    special: [
      1,
      3,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Solis',
      deptNombre: 'Maldonado',
    },
  },
  '464-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: '#Minas',
      deptNombre: 'Lavalleja',
    },
  },
  '173-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Casupa',
      deptNombre: 'Lavalleja',
    },
  },
  '423-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colón',
      deptNombre: 'Lavalleja',
    },
  },
  '441-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Estación Solis',
      deptNombre: 'Lavalleja',
    },
  },
  '91-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Jose Batlle y Ordoñez',
      deptNombre: 'Lavalleja',
    },
  },
  '105-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Jose Pedro Varela',
      deptNombre: 'Lavalleja',
    },
  },
  '161-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Delicias',
      deptNombre: 'Lavalleja',
    },
  },
  '190-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Mariscala',
      deptNombre: 'Lavalleja',
    },
  },
  '48-10': {
    agency: [
      3,
    ],
    simple: [
      3,
    ],
    special: [
      3,
    ],
    _meta: {
      locNombre: 'Minas',
      deptNombre: 'Lavalleja',
    },
  },
  '174-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso de La Matada',
      deptNombre: 'Lavalleja',
    },
  },
  '289-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Piraraja',
      deptNombre: 'Lavalleja',
    },
  },
  '149-10': {
    agency: [
      3,
    ],
    simple: [
      3,
    ],
    special: [
      3,
    ],
    _meta: {
      locNombre: 'Solis de Mataojo',
      deptNombre: 'Lavalleja',
    },
  },
  '279-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Solis Grande',
      deptNombre: 'Lavalleja',
    },
  },
  '347-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Serrana',
      deptNombre: 'Lavalleja',
    },
  },
  '252-10': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Zapican',
      deptNombre: 'Lavalleja',
    },
  },
  '285-11': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Chapicuy',
      deptNombre: 'Paysandú',
    },
  },
  '374-11': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Constancia',
      deptNombre: 'Paysandú',
    },
  },
  '458-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Guaviyú Termas',
      deptNombre: 'Paysandú',
    },
  },
  '97-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Guichon',
      deptNombre: 'Paysandú',
    },
  },
  '52-11': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Paysandú',
      deptNombre: 'Paysandú',
    },
  },
  '439-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Piedra Sola',
      deptNombre: 'Paysandú',
    },
  },
  '406-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Piedras Coloradas',
      deptNombre: 'Paysandú',
    },
  },
  '362-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Porvenir',
      deptNombre: 'Paysandú',
    },
  },
  '440-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Beisso',
      deptNombre: 'Paysandú',
    },
  },
  '344-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Gallinal',
      deptNombre: 'Paysandú',
    },
  },
  '239-11': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Quebracho',
      deptNombre: 'Paysandú',
    },
  },
  '349-11': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Tambores',
      deptNombre: 'Paysandú',
    },
  },
  '416-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cañada Nieto',
      deptNombre: 'Soriano',
    },
  },
  '54-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cardona',
      deptNombre: 'Soriano',
    },
  },
  '93-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colonia Larrañaga',
      deptNombre: 'Soriano',
    },
  },
  '64-12': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Dolores',
      deptNombre: 'Soriano',
    },
  },
  '124-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Egaña',
      deptNombre: 'Soriano',
    },
  },
  '370-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Estación Bizcocho',
      deptNombre: 'Soriano',
    },
  },
  '224-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Jose Enrique Rodo',
      deptNombre: 'Soriano',
    },
  },
  '53-12': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Mercedes',
      deptNombre: 'Soriano',
    },
  },
  '179-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Palmitas',
      deptNombre: 'Soriano',
    },
  },
  '388-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Palo Solo',
      deptNombre: 'Soriano',
    },
  },
  '112-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Agraciada',
      deptNombre: 'Soriano',
    },
  },
  '286-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Palmar',
      deptNombre: 'Soriano',
    },
  },
  '153-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Risso',
      deptNombre: 'Soriano',
    },
  },
  '259-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Catalina',
      deptNombre: 'Soriano',
    },
  },
  '446-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Darwin',
      deptNombre: 'Soriano',
    },
  },
  '354-12': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Villa Soriano',
      deptNombre: 'Soriano',
    },
  },
  '134-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Agraciada',
      deptNombre: 'Colonia',
    },
  },
  '302-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Artilleros',
      deptNombre: 'Colonia',
    },
  },
  '386-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Blanca Arena',
      deptNombre: 'Colonia',
    },
  },
  '400-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Britópolis',
      deptNombre: 'Colonia',
    },
  },
  '429-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Los Pinos',
      deptNombre: 'Colonia',
    },
  },
  '401-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Playa Azul',
      deptNombre: 'Colonia',
    },
  },
  '63-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Balneario Santa Ana',
      deptNombre: 'Colonia',
    },
  },
  '59-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Carmelo',
      deptNombre: 'Colonia',
    },
  },
  '422-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro Carmelo',
      deptNombre: 'Colonia',
    },
  },
  '55-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Colonia del Sacramento',
      deptNombre: 'Colonia',
    },
  },
  '77-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colonia Suiza',
      deptNombre: 'Colonia',
    },
  },
  '133-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Colonia Valdense',
      deptNombre: 'Colonia',
    },
  },
  '175-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Conchillas',
      deptNombre: 'Colonia',
    },
  },
  '426-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'El Ensueño',
      deptNombre: 'Colonia',
    },
  },
  '128-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Florencio Sanchez',
      deptNombre: 'Colonia',
    },
  },
  '58-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Juan Lacaze',
      deptNombre: 'Colonia',
    },
  },
  '330-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Campana',
      deptNombre: 'Colonia',
    },
  },
  '221-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Paz',
      deptNombre: 'Colonia',
    },
  },
  '182-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Miguelete',
      deptNombre: 'Colonia',
    },
  },
  '122-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Nueva Helvecia',
      deptNombre: 'Colonia',
    },
  },
  '56-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Nueva Palmira',
      deptNombre: 'Colonia',
    },
  },
  '106-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Ombues de Lavalle',
      deptNombre: 'Colonia',
    },
  },
  '459-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paraje Colonia Cosmopolit',
      deptNombre: 'Colonia',
    },
  },
  '359-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Paso Antolin',
      deptNombre: 'Colonia',
    },
  },
  '329-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Playa Fomento',
      deptNombre: 'Colonia',
    },
  },
  '427-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Puerto Inglés',
      deptNombre: 'Colonia',
    },
  },
  '232-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Riachuelo',
      deptNombre: 'Colonia',
    },
  },
  '70-13': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Rosario',
      deptNombre: 'Colonia',
    },
  },
  '188-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Roque',
      deptNombre: 'Colonia',
    },
  },
  '424-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Ana (Colonia)',
      deptNombre: 'Colonia',
    },
  },
  '85-13': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tarariras',
      deptNombre: 'Colonia',
    },
  },
  '437-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Arenitas Blancas',
      deptNombre: 'Salto',
    },
  },
  '274-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Belen',
      deptNombre: 'Salto',
    },
  },
  '335-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Colonia Itapebí',
      deptNombre: 'Salto',
    },
  },
  '263-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Constitucion',
      deptNombre: 'Salto',
    },
  },
  '432-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Pueblo Lavalleja',
      deptNombre: 'Salto',
    },
  },
  '345-14': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rincón de Valentín',
      deptNombre: 'Salto',
    },
  },
  '62-14': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Salto',
      deptNombre: 'Salto',
    },
  },
  '415-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Arrozal Treinta y Tres',
      deptNombre: 'Treinta y Tres',
    },
  },
  '117-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro Chato(treinta...)',
      deptNombre: 'Treinta y Tres',
    },
  },
  '372-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Gral. Enrique Martínez',
      deptNombre: 'Treinta y Tres',
    },
  },
  '332-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'La Charqueada',
      deptNombre: 'Treinta y Tres',
    },
  },
  '355-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rincón',
      deptNombre: 'Treinta y Tres',
    },
  },
  '208-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Clara de Olimar',
      deptNombre: 'Treinta y Tres',
    },
  },
  '66-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Treinta y Tres',
      deptNombre: 'Treinta y Tres',
    },
  },
  '357-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Valentines',
      deptNombre: 'Treinta y Tres',
    },
  },
  '204-15': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Vergara',
      deptNombre: 'Treinta y Tres',
    },
  },
  '118-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Algorta',
      deptNombre: 'Rio Negro',
    },
  },
  '74-16': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Fray Bentos',
      deptNombre: 'Rio Negro',
    },
  },
  '430-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Las Cañas',
      deptNombre: 'Rio Negro',
    },
  },
  '380-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Los Arrayanes',
      deptNombre: 'Rio Negro',
    },
  },
  '250-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Nuevo Berlin',
      deptNombre: 'Rio Negro',
    },
  },
  '278-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'San Javier',
      deptNombre: 'Rio Negro',
    },
  },
  '341-16': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tres bocas',
      deptNombre: 'Rio Negro',
    },
  },
  '75-16': {
    agency: [
      2,
    ],
    simple: [
      2,
    ],
    special: [
      2,
    ],
    _meta: {
      locNombre: 'Young',
      deptNombre: 'Rio Negro',
    },
  },
  '328-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Acegua',
      deptNombre: 'Cerro Largo',
    },
  },
  '454-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Arbolito',
      deptNombre: 'Cerro Largo',
    },
  },
  '428-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Arévalo',
      deptNombre: 'Cerro Largo',
    },
  },
  '453-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Bañado Medina',
      deptNombre: 'Cerro Largo',
    },
  },
  '456-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Cerro de las cuentas',
      deptNombre: 'Cerro Largo',
    },
  },
  '258-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Fraile Muerto',
      deptNombre: 'Cerro Largo',
    },
  },
  '356-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Guazunambi',
      deptNombre: 'Cerro Largo',
    },
  },
  '267-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Lago Merin',
      deptNombre: 'Cerro Largo',
    },
  },
  '404-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Mangrullo',
      deptNombre: 'Cerro Largo',
    },
  },
  '76-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Melo',
      deptNombre: 'Cerro Largo',
    },
  },
  '303-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Noblia',
      deptNombre: 'Cerro Largo',
    },
  },
  '366-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Placido Rosas',
      deptNombre: 'Cerro Largo',
    },
  },
  '198-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rio Branco',
      deptNombre: 'Cerro Largo',
    },
  },
  '207-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Santa Clara de Olimar',
      deptNombre: 'Cerro Largo',
    },
  },
  '455-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Toledo (Cerro Largo)',
      deptNombre: 'Cerro Largo',
    },
  },
  '150-17': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tupambae',
      deptNombre: 'Cerro Largo',
    },
  },
  '351-18': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Masoller',
      deptNombre: 'Rivera',
    },
  },
  '227-18': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Minas de Corrales',
      deptNombre: 'Rivera',
    },
  },
  '116-18': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Rivera',
      deptNombre: 'Rivera',
    },
  },
  '144-18': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tranqueras',
      deptNombre: 'Rivera',
    },
  },
  '253-18': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Vichadero',
      deptNombre: 'Rivera',
    },
  },
  '139-19': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Artigas',
      deptNombre: 'Artigas',
    },
  },
  '254-19': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Baltazar Brum',
      deptNombre: 'Artigas',
    },
  },
  '140-19': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Bella Union',
      deptNombre: 'Artigas',
    },
  },
  '301-19': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Javier de Viana',
      deptNombre: 'Artigas',
    },
  },
  '260-19': {
    agency: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    simple: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    special: [
      1,
      2,
      3,
      4,
      5,
      6,
    ],
    _meta: {
      locNombre: 'Tomas Gomensoro',
      deptNombre: 'Artigas',
    },
  },
};

const ref = departmentFrequencyByLoc;

// -----------------------------------------------------------------------------
// Config: corte de mañana/tarde para SIMPLE (HHmm)
const SIMPLE_CUTOFF = 1300;
// -----------------------------------------------------------------------------

function weekday1to7(d) {
  const js = d.getDay();
  return js === 0 ? 7 : js;
}

const addDays = (d, n) => {
  const x = new Date(d.getTime());
  x.setDate(x.getDate() + n);
  return x;
};

function sanitizeDays(freq) {
  if (!Array.isArray(freq) || !freq.length) return null;
  const clean = freq
    .map(n => Number(n))
    .filter(n => n >= 1 && n <= 7);
  return clean.length ? new Set(clean) : null;
}

// Acepta 'optionType' y soporta tanto array como objeto { simple, special, agency, * }
// Nota: 'ref' debe existir en tu scope con el mapa de frecuencias (p. ej. departmentFrequencyByLoc)
function allowedDaysForDepartment(departmentIdOrLocKey, optionType) {
  const rule = ref[departmentIdOrLocKey];

  // Caso 1: array => aplica a todos los tipos
  if (Array.isArray(rule)) {
    const s = sanitizeDays(rule);
    if (s) return s;
  }

  // Caso 2: objeto por tipo
  if (rule && typeof rule === 'object') {
    const specific = sanitizeDays(rule[optionType]);
    if (specific) return specific;

    // comodín opcional '*'
    const star = sanitizeDays(rule['*']);
    if (star) return star;
  }

  // Fallback: Lun–Sáb
  return new Set([1, 2, 3, 4, 5, 6]);
}

function isAllowedDay(d, allowedSet) {
  return allowedSet.has(weekday1to7(d));
}

function nextAllowedDate(d, allowedSet) {
  let x = new Date(d.getTime());
  if (isAllowedDay(x, allowedSet)) return x;
  do {
    x = addDays(x, 1);
  } while (!isAllowedDay(x, allowedSet));
  return x;
}

// --- helpers para offset ---
function extractOffsetFromISO(s) {
  if (typeof s !== 'string') return null;
  const m = s.match(/([+-]\d{2}:\d{2}|Z)$/);
  if (!m) return null;
  return m[1] === 'Z' ? '+00:00' : m[1];
}

function offsetFromMinutes(mins) {
  const sign = mins <= 0 ? '+' : '-';
  const abs = Math.abs(mins);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${sign}${hh}:${mm}`;
}

// busca offset en opciones; si no, usa el de minDate; si no, el local
function inferOffset(options, minDateISO) {
  if (Array.isArray(options)) {
    for (const o of options) {
      if (o && o.optionType === 'simple' && typeof o.date === 'string') {
        const off = extractOffsetFromISO(o.date);
        if (off) return off;
      }
      if (o && o.optionType === 'special' && Array.isArray(o.timeSlots)) {
        const first = o.timeSlots.find(ts => typeof ts.date === 'string');
        if (first) {
          const off = extractOffsetFromISO(first.date);
          if (off) return off;
        }
      }
    }
  }
  const offMin = extractOffsetFromISO(minDateISO);
  if (offMin) return offMin;
  return offsetFromMinutes(new Date().getTimezoneOffset());
}

function toMidnightLocalISO(d, offset) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T00:00:00.000${offset}`;
}

// --- fix de "un día antes": parseo local ---
function parseLocalYMD(iso) {
  if (typeof iso !== 'string') return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10) - 1;
  const d = parseInt(m[3], 10);
  return new Date(y, mo, d); // medianoche local
}

// Normaliza minDate a medianoche local y salta días no permitidos
function normalizeStart(minDateISO, allowedSet) {
  const local = parseLocalYMD(minDateISO);
  const start = local || (() => {
    const inDate = new Date(minDateISO);
    return new Date(inDate.getFullYear(), inDate.getMonth(), inDate.getDate());
  })();
  return nextAllowedDate(start, allowedSet);
}

// Agrupa SPECIAL por día (basado en ts.date)
function groupSlotsByDay(slots) {
  const groups = [];
  const keyOf = s => (typeof s === 'string' ? s.slice(0, 10) : '');
  for (const ts of slots) {
    const k = keyOf(ts.date);
    const last = groups[groups.length - 1];
    if (!last || last.dateKey !== k) {
      groups.push({ dateKey: k, slots: [ts] });
    } else {
      last.slots.push(ts);
    }
  }
  return groups;
}

// Agrupa AGENCY por día (basado en ts.id: "YYYY-MM-DDT...")
function groupSlotsByDayAgency(slots) {
  const groups = [];
  const keyOf = s => (typeof s === 'string' ? s.slice(0, 10) : '');
  for (const ts of slots) {
    const k = keyOf(ts.id);
    const last = groups[groups.length - 1];
    if (!last || last.dateKey !== k) {
      groups.push({ dateKey: k, slots: [ts] });
    } else {
      last.slots.push(ts);
    }
  }
  return groups;
}

// formateo de IDs
function formatSimpleIdFutureDate(iso, startHour, endHour) {
  const sh = typeof startHour === 'number' ? startHour : Number(startHour) || 0;
  const eh = typeof endHour === 'number' ? endHour : Number(endHour) || 0;
  return `simple-${iso}-${sh}.${eh}`;
}

function formatSpecialIdFutureDate(iso, startHour, endHour) {
  const sh = typeof startHour === 'number' ? startHour : Number(startHour) || 0;
  const eh = typeof endHour === 'number' ? endHour : Number(endHour) || 0;
  return `special-${iso}-${sh}.${eh}`;
}

// -------------------- Helpers para SIMPLE: agrupado y shift --------------------
function extractYMDFromSimple(item) {
  // 1) Preferimos item.date
  if (item && typeof item.date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(item.date)) {
    return item.date.slice(0, 10);
  }
  // 2) Fallback: parsear del id: "simple-YYYY-MM-DDT..."
  if (item && typeof item.id === 'string') {
    const m = item.id.match(/^simple-(\d{4}-\d{2}-\d{2})T/);
    if (m) return m[1];
  }
  return '__unknown__';
}

function groupSimpleBySourceDay(simpleItems) {
  const map = new Map();
  for (const it of simpleItems) {
    const key = extractYMDFromSimple(it);
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(it);
  }
  const keys = Array.from(map.keys());
  const known = keys.filter(k => k !== '__unknown__').sort(); // YYYY-MM-DD ordena OK
  const unknown = keys.filter(k => k === '__unknown__');
  const finalKeys = [...known, ...unknown];
  return finalKeys.map(k => ({ dateKey: k, items: map.get(k) }));
}

// 1..7 (Luxon: 1=Lun … 7=Dom)
function weekdayFromDateTime(dt) {
  const a = dt.weekday;
  return typeof a === 'number' ? a : null;
}

// Para SIMPLE: 1=mañana, 2=tarde (corte configurable)
function getSimpleShift(startHour, endHour) {
  const cutoff = SIMPLE_CUTOFF;
  const s = Number(startHour) || 0;
  const e = Number(endHour) || 0;
  if (e <= cutoff) return 1; // todo en mañana
  if (s >= cutoff) return 2; // todo en tarde
  const mid = (s + e) / 2; // cruza: decide por mayoría
  return mid <= cutoff ? 1 : 2;
}

// (Opcional) deduplicar por (futureDate ISO, startHour, endHour)
function dedupeSimpleByFutureSlot(simpleItems) {
  const seen = new Set();
  const out = [];
  for (const it of simpleItems) {
    const isoDay = it && it.futureDate && it.futureDate.toISODate && it.futureDate.toISODate() || '';
    const key = `${isoDay}|${it.startHour}|${it.endHour}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push(it);
    }
  }
  return out;
}

// -----------------------------------------------------------------------------
// Asigna futuras fechas/ids
// - 'simple': agrupa por día de origen y asigna MISMA futureDate a todas sus franjas
//             + futureWeekday (1..7) + simpleShift (1 mañana / 2 tarde)
// - 'special': agrupa por día (timeSlots) y avanza por grupos + futureWeekday
// - 'agency' : avanza por slot, agrupado por día a nivel id   + futureWeekday
// -----------------------------------------------------------------------------
export function assignFutureDates(options, minDateISO, locationKey) {
  try {
    if (!Array.isArray(options) || !options.length) return options;

    const offset = inferOffset(options, minDateISO);

    // Frecuencias por tipo
    const allowedSimple = allowedDaysForDepartment(locationKey, 'simple');
    const allowedSpecial = allowedDaysForDepartment(locationKey, 'special');
    const allowedAgency = allowedDaysForDepartment(locationKey, 'agency');

    // -------- SIMPLE (agrupado por día de ORIGEN) --------
    const simpleItems = options.filter(o => o && o.optionType === 'simple');
    if (simpleItems.length) {
      let cursorSimple = normalizeStart(minDateISO, allowedSimple);
      const groups = groupSimpleBySourceDay(simpleItems);

      for (let gi = 0; gi < groups.length; gi += 1) {
        const iso = toMidnightLocalISO(cursorSimple, offset);
        for (const it of groups[gi].items) {
          it.futureDate = DateTime.fromISO(iso);
          it.idFutureDate = formatSimpleIdFutureDate(iso, it.startHour, it.endHour);
          it.futureWeekday = weekdayFromDateTime(it.futureDate); // 1..7
          it.simpleShift = getSimpleShift(it.startHour, it.endHour); // 1/2
        }
        // avanzar una sola vez por grupo (día de origen)
        cursorSimple = nextAllowedDate(addDays(cursorSimple, 1), allowedSimple);
      }

      // (Opcional) dedupe si tu feed puede traer duplicados
      const deduped = dedupeSimpleByFutureSlot(simpleItems);
      if (deduped.length !== simpleItems.length) {
        let i = 0;
        for (let j = 0; j < options.length; j += 1) {
          if (options[j] && options[j].optionType === 'simple') {
            options[j] = deduped[i++] || null;
          }
        }
        // limpia nulls si quedaron
        for (let k = options.length - 1; k >= 0; k -= 1) {
          if (options[k] === null) options.splice(k, 1);
        }
      }
    }

    // -------- SPECIAL (por grupos/día de sus timeSlots) --------
    for (const item of options) {
      if (item && item.optionType === 'special' && Array.isArray(item.timeSlots) && item.timeSlots.length) {
        let localCursor = normalizeStart(minDateISO, allowedSpecial);
        const groups = groupSlotsByDay(item.timeSlots);

        for (let gi = 0; gi < groups.length; gi += 1) {
          const iso = toMidnightLocalISO(localCursor, offset);
          for (const ts of groups[gi].slots) {
            ts.futureDate = DateTime.fromISO(iso);
            ts.idFutureDate = formatSpecialIdFutureDate(iso, ts.startHour, ts.endHour);
            ts.futureWeekday = weekdayFromDateTime(ts.futureDate); // 1..7
            ts.simpleShift = getSimpleShift(ts.startHour, ts.endHour);
          }
          localCursor = nextAllowedDate(addDays(localCursor, 1), allowedSpecial);
        }
      }
    }

    // -------- AGENCY (cursor por slot, agrupado por día a nivel id) --------
    for (const item of options) {
      if (item && item.optionType === 'agency' && Array.isArray(item.timeSlots) && item.timeSlots.length) {
        let localCursor = normalizeStart(minDateISO, allowedAgency);
        const groups = groupSlotsByDayAgency(item.timeSlots);

        for (let gi = 0; gi < groups.length; gi += 1) {
          for (const ts of groups[gi].slots) {
            const iso = toMidnightLocalISO(localCursor, offset);
            ts.futureDate = DateTime.fromISO(iso);
            ts.idFutureDate = formatSpecialIdFutureDate(iso, ts.startHour, ts.endHour);
            ts.futureWeekday = weekdayFromDateTime(ts.futureDate); // 1..7
            localCursor = nextAllowedDate(addDays(localCursor, 1), allowedAgency);
          }
        }
      }
    }

    return options;
  } catch (error) {
    console.log(error);
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/helpers/NextDateHelper.js